import {Box, Stack, Text, Image} from '@chakra-ui/core';
import React from 'react';
import {Button} from './Button';

import {getModelImage} from 'utils/images';

import {darkgrey, yellow} from 'styles/constants';

const RecommendedModel = ({setSettingsOpen, recommendedSleipner, moveToSummary}) => {
	const modelImageSource = getModelImage(recommendedSleipner.model);

	return (
		<Box>
			<Stack p={6} mb={4} bg={yellow} rounded={2} alignItems="center">
				<Text fontSize={'md'} pb={2}>
					Recommended Sleipner E-Series model based on excavator weight
				</Text>
				<Text
					textAlign={'center'}
					fontSize={'100px'}
					mt={8}
					pb={8}
					color={darkgrey}
					fontWeight="bold"
					lineHeight={0.5}
				>
					{recommendedSleipner?.model ?? '---'}
				</Text>
				<Image
					src={modelImageSource}
					maxW={{base: 300, lg: '100%'}}
					alt="suitable sleipner model"
				/>
			</Stack>
			<Button border={'3px solid #333'} onClick={() => setSettingsOpen(true)}>
				Adjust Values
			</Button>

			<Button isPrimary _hover={'none'} onClick={moveToSummary}>
				Continue
			</Button>
		</Box>
	);
};

export default RecommendedModel;
